import React, {Component} from 'react';

export class Sandbox extends Component {
    static displayName = Sandbox.name;

    svg_grid() {
        var columns = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        var rows = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        return (
            <div className="svg-layer">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="250"
                    height="250px"
                >
                    {columns.map(column =>
                        rows.map(row =>
                            <rect key={row} x={(10 + column * 20) + "px"} y={(10 + row * 20) + "px"} width="20"
                                  height="20"
                                  fill={row < 3 ? "blue" : "yellow"} stroke="black"/>
                        )
                    )}
                </svg>
            </div>
        );
    }

    svg_graph() {
        var columns = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        var rows = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        return (
            <div className="svg-layer">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="200"
                    height="200px"
                >
                    {columns.map(column =>
                        rows.map(row =>
                            <rect key={row} x={(column * 20) + "px"} y={(row * 20) + "px"} width="20" height="20"
                                  fill="white" stroke="lightgrey"/>
                        )
                    )}
                    <line x1="10" y1="120" x2="190" y2="120" stroke="black" strokeWidth="2"/>
                    <line x1="80" y1="10" x2="80" y2="190" stroke="black" strokeWidth="2"/>
                    <text fill="black" fontSize="12" fontFamily="Verdana" x="65" y="106">1</text>
                    <text fill="black" fontSize="12" fontFamily="Verdana" x="96" y="135">1</text>
                    <text fill="black" fontSize="12" fontFamily="Verdana" x="191" y="124">x</text>
                    <text fill="black" fontSize="12" fontFamily="Verdana" x="76" y="8">y</text>
                    <line x1="20" y1="20" x2="180" y2="180" stroke="black" strokeWidth="4"/>
                </svg>
            </div>
        );
    }

    try_svg() {
        return (
            <div className="svg-layer">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="800px"
                    height="600px"
                >
                    <circle cx="20px" cy="100px" r="10px" stroke="black"/>
                    <circle cx="100px" cy="100px" r="10px" stroke="black" strokeWidth="1" fill="yellow"/>
                    <rect x="50px" y="200px" rx="20px" ry="20px" width="100" height="100"/>
                    <polygon points="100,10 40,198 190,78 10,78 160,198"
                             style={{fill: "lime", "fillRule": "evenodd", stroke: "purple", "strokeWidth": 5}}/>
                    <ellipse cx="250" cy="70" rx="85" ry="55" fill="black"/>
                    <text fill="#ffffff" fontSize="45" fontFamily="Verdana" x="200" y="86">SVG</text>
                    <line x1="0" y1="0" x2="200" y2="200" stroke="black" strokeWidth="10"/>
                </svg>
            </div>
        );
    }

    onCheckboxChange(event) {
        console.log(event);
    }

    render() {
        return (
            <div>
                {this.svg_graph()}
                {/*{this.svg_grid()}*/}
                {/*{this.try_svg()}*/}
            </div>
        );
    }
}
